import { Link, useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CalendarDays, FileText, Home, LogOut } from "lucide-react";
import { clearMeSession, getMeSession } from "@/lib/auth/storage";

const links = [
  { href: "/me", label: "Today", icon: Home, exact: true },
  { href: "/me/notice", label: "Notice", icon: FileText },
  { href: "/me/history", label: "History", icon: CalendarDays },
];

export function MeNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const person = getMeSession();

  return (
    <>
      <header className="border-b bg-white px-4 py-4">
        <p className="text-xs font-semibold uppercase tracking-wider text-saffron-700">
          BCEC Attendance
        </p>
        <h1 className="text-xl font-semibold">
          {person?.name ? `Namaste, ${person.name.split(" ")[0]}` : "My Attendance"}
        </h1>
      </header>
      <nav className="fixed bottom-0 left-0 right-0 z-40 border-t bg-white pb-safe">
        <div className="mx-auto flex max-w-lg items-stretch justify-around">
          {links.map(({ href, label, icon: Icon, exact }) => {
            const active = exact
              ? pathname === href
              : pathname.startsWith(href);
            return (
              <Link
                key={href}
                to={href}
                className={cn(
                  "flex flex-1 flex-col items-center gap-1 py-3 text-xs font-medium",
                  active ? "text-saffron-700" : "text-muted-foreground"
                )}
              >
                <Icon className="h-5 w-5" />
                {label}
              </Link>
            );
          })}
          <button
            type="button"
            onClick={() => {
              clearMeSession();
              navigate("/me/login");
            }}
            className="flex flex-1 flex-col items-center gap-1 py-3 text-xs font-medium text-muted-foreground"
          >
            <LogOut className="h-5 w-5" />
            Logout
          </button>
        </div>
      </nav>
    </>
  );
}
